import { makeApiRequest } from '@/src/lib/api-request'
import {request, requestV3} from '@/src/lib/customAxios'
import { useProfile } from '@/src/store/profile-store'
import { useUser } from '@/src/store/user-store'
import { User } from '@/src/types/user'
import { useMutation } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'

export interface ChannelData {
  channelName: string
  coverUrl: string
  imageUrl: string
  waterMarkImage: string
  bio: string
  instagramLink: string
  facebookLink: string
  emailLink: string
  twitterLink: string
  websiteLink: string
}

export const useUpdateChannelMutation = () => {
  const {
    tempIconFile,
    tempCoverIconFile,
    setTempCoverIconFile,
    setTempIconFile,
  } = useProfile()
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['user', 'update'],
    mutationFn: async (data: ChannelData) => {
      if (tempIconFile) {
        const formData = new FormData()
        formData.append('file', tempIconFile)
        try {
          const response = await requestV3({
            url: '/ImageUpload/uploadThumbnail',
            method: 'POST',
            data: formData,
          })
          if (!response.data.fileName) {
            throw new Error('Failed to upload image')
          }
          data.imageUrl = encodeURI(response.data.fullUrl)
        } catch (e) {
          throw new Error('Failed to upload image')
        } finally {
          setTempIconFile(null)
        }
      }
      if (tempCoverIconFile) {
        const formData = new FormData()
        formData.append('file', tempCoverIconFile)
        try {
          const response = await requestV3({
            url: '/ImageUpload/uploadThumbnail',
            method: 'POST',
            data: formData,
          })
          if (!response.data.fileName) {
            throw new Error('Failed to upload image')
          }
          data.coverUrl = response.data.fullUrl
        } catch (e) {
          throw new Error('Failed to upload image')
        } finally {
          setTempCoverIconFile(null)
        }
      }

      setTempCoverIconFile(null)
      setTempIconFile(null)

      await makeApiRequest({
        url: '/Channel/editMyChannelDetails',
        method: 'POST',
        data: data,
        isAuthenticated: true,
        fallbackError: 'Failed to update user details',
        isV3Api:true
      })
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['channel-details'] })
      await queryClient.invalidateQueries({ queryKey: ['user', 'me'] })
    },
  })
}
